import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Contract } from "../../../model/contract";

@Component({
  selector: 'aw-contract-dialog',
  templateUrl: './contract-dialog.component.html',
  styleUrls: ['./contract-dialog.component.scss']
})
export class ContractDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Contract,
    public dialogRef: MatDialogRef<ContractDialogComponent>,
  ) {


  }

  ngOnInit(): void {

  }


}


